export default "/images/09 Step2Plan-Consultant-To view completed self-assessments-01.png?3987921fc1f15e79567274abf896245b";